/* http.js — خواندن امن پاسخ سرور
   هر پاسخی که JSON نباشد (صفحهٔ خطای HTML، قطع شدن سرور هنگام ری‌استارت، پروکسی) به‌جای
   اینکه صفحه را بی‌صدا نگه دارد، به یک پیام خطای قابل‌نمایش تبدیل می‌شود. */

export async function jsonOf(r) {
  try {
    return await r.json();
  } catch (e) {
    const m = `پاسخ نامعتبر از سرور (کد ${r.status})`;
    return { ok: false, error: m, msg: m, status: r.status };
  }
}

export function netErr() {
  const m = 'ارتباط با سرور برقرار نشد؛ چند لحظه بعد دوباره تلاش کنید';
  return { ok: false, error: m, msg: m, status: 0 };
}
